import { useDispatch, useSelector } from "react-redux";
import { toggleActividadAplicacionActiveThunk } from "../../store/reducers/actividadesAplicacion/actividadesAplicacion.thunks";
import Modal from "../UI/Modal";
import Loader from "../UI/Loader";
import { closeConfirmToggle } from "../../store/reducers/actividadesAplicacion/actividadesAplicacion.reducer";

const ActivitiesApplicationConfirmToggleModal = () => {
  const dispatch = useDispatch();
  const { confirmModalOpen, toggleActividadId, toggling } = useSelector(
    (state) => state.actividadesAplicacion,
  );

  const actividad = useSelector((state) =>
    state.actividadesAplicacion.list.find((a) => a.id === toggleActividadId),
  );

  const handleConfirm = () => {
    dispatch(toggleActividadAplicacionActiveThunk(toggleActividadId));
  };

  return (
    <Modal
      open={confirmModalOpen}
      onClose={() => dispatch(closeConfirmToggle())}
      title="Confirmación"
      size="sm"
    >
      {toggling ? (
        <Loader center text="Actualizando actividad..." type="dots" size="sm" />
      ) : (
        <>
          <p className="mb-3">
            ¿Seguro que quieres{" "}
            <strong>{actividad?.is_active ? "desactivar" : "activar"}</strong>{" "}
            la actividad{" "}
            <strong>"{actividad?.nombre || actividad?.actividad}"</strong>?
          </p>
          <div className="d-flex justify-content-end gap-2">
            <button
              className="btn btn-secondary"
              onClick={() => dispatch(closeConfirmToggle())}
            >
              Cancelar
            </button>
            <button className="btn btn-primary" onClick={handleConfirm}>
              Confirmar
            </button>
          </div>
        </>
      )}
    </Modal>
  );
};

export default ActivitiesApplicationConfirmToggleModal;
